var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-404"},[_c('h4',{staticClass:"mb50"},[_vm._v(" "+_vm._s(_vm.message)+" ")]),_c('y-button',{nativeOn:{"click":function($event){return _vm.$emit('refresh')}}},[_vm._v(" "+_vm._s(_vm.$t('button.refresh'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }